import { Icon, IconName, Text } from "@zapier/design-system";

import styles from "./ProductCard.module.css";
import { MetaProduct } from "src/server/zsl/templates/types";

interface ProductProps {
  product: MetaProduct;
}

interface ProductInfo {
  href: string;
  icon: IconName;
  title: string;
}

const productInfo: { [K in MetaProduct]: ProductInfo } = {
  interfaces: {
    href: "https://zapier.com/interfaces",
    icon: "navInterfaces",
    title: "Interfaces",
  },
  tables: {
    href: "https://zapier.com/tables",
    icon: "navTables",
    title: "Tables",
  },
  zaps: {
    href: "https://zapier.com",
    icon: "miscBoltAlt",
    title: "Zaps",
  },
  chatbot: {
    href: "https://zapier.com/ai/chatbot",
    icon: "navAIChatbot",
    title: "Chatbots",
  },
  canvas: {
    href: "https://zapier.com/app/canvas",
    icon: "navCanvas",
    title: "Canvas",
  },
};

export const ProductCard = ({ product }: ProductProps) => {
  const { href, icon, title } = productInfo[product];

  return (
    <div className={styles.wrapper}>
      <div className={styles.iconBackground}>
        <div className={styles.iconWrapper}>
          <Icon name={icon} size={40} color="BrandOrange" />
        </div>
      </div>
      <a className={styles.unstyledLink} href={href}>
        <Text type="Body4">{title}</Text>
      </a>
    </div>
  );
};
